// Utility to add ordinal suffix
function getOrdinal(n) {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

// Format function
export function formatDate(dateString, { short = false, hideYear = false } = {}) {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date)) return dateString; // fallback if invalid

  const day = getOrdinal(date.getDate());

  // Month formatting
  const month = date.toLocaleString("en-US", {
    month: short ? "short" : "long",
  });

  const year = date.getFullYear();

  // Build final string
  return hideYear ? `${day} ${month}` : `${day} ${month}, ${year}`;
}

export function formatDateToYMD(date) {
  if (!date) return "";
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0"); // Months start at 0
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

export function formatDateLocal(date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month?.length < 2) month = "0" + month;
  if (day?.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

// Format like "Oct 1, 10:15" or "Oct 1, 10:15 AM"
export function formatDateWithTime(dateString, { use12Hour = false } = {}) {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date)) return dateString; // fallback if invalid

  const month = date.toLocaleString("en-US", { month: "short" });
  const day = date.getDate();

  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");

  if (use12Hour) {
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // convert 0 -> 12 for midnight
    return `${month} ${day}, ${hours}:${minutes} ${ampm}`;
  }

  // default 24-hour format
  return `${month} ${day}, ${hours.toString().padStart(2, "0")}:${minutes}`;
}
